import React, { Component } from 'react'
import spinkit from 'spinkit/scss/spinners/10-fading-circle.scss'
import classes from './Loader.scss'

class Loader extends Component {
  render () {
    const { blue } = this.props
    return (
      <div className={`${spinkit['sk-fading-circle']} ${classes.loaderCircle} ${blue && classes.blueContainer}`}>
        <div className={`${spinkit['sk-circle1']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle2']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle3']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle4']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle5']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle6']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle7']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle8']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle10']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle11']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
        <div className={`${spinkit['sk-circle12']} ${spinkit['sk-circle']} ${blue ? classes.loadingColor : classes.loaderColor}`} />
      </div>
    )
  }
}

export default Loader



// WEBPACK FOOTER //
// ./src/components/Loader.js